module.exports = __webpack_public_path__ + "public/11bd16716c77983bc363e42d89e3c2a2.ttf";